import { Reveal } from './Reveal';
import { LANDING_ANCHORS, LANDING_HOW_IT_WORKS } from '../../domain/landingContent';

/** Três passos de implantação. */
export function LandingHowItWorks() {
  return (
    <section
      id={LANDING_ANCHORS.comoFunciona}
      className="mx-auto max-w-6xl scroll-mt-24 px-4 py-24 sm:px-6 sm:py-32"
    >
      <Reveal className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Como funciona
        </h2>
        <p className="mt-3 text-sm text-slate-400 sm:text-base">
          Do primeiro link na TV Box ao cliente pedindo música — em três passos.
        </p>
      </Reveal>

      <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {LANDING_HOW_IT_WORKS.map((step, i) => (
          <Reveal key={step.passo} delay={i * 0.08}>
            <li className="relative min-w-0 rounded-[2rem] border border-white/[0.06] bg-white/[0.03] p-6 sm:p-7">
              <span className="text-4xl font-black tracking-tighter text-orange-500/30">
                {step.passo}
              </span>
              <h3 className="mt-3 text-lg font-semibold text-white">{step.titulo}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{step.descricao}</p>
            </li>
          </Reveal>
        ))}
      </ol>
    </section>
  );
}
